// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_page__ylqiB {
  min-height: 100vh;
  padding: 1rem 1rem 2rem;
}

.styles_card__SlTbm {
  position: relative;
  max-width: 1500px;
  margin: 0.35rem auto 0;
  background: #ffffff;
  border-radius: 14px;
  padding: 1.1rem 1.35rem 0.6rem;
  box-shadow: 0 10px 24px rgba(3, 15, 36, 0.14);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_infoGrid__MCnYQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  padding: 1.25rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e1e6ee;
}

.styles_infoItem__cT0C4 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  color: #64748b;
}

.styles_infoItem__cT0C4 strong {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 600;
}

.styles_totalsRow__BEStY {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.styles_totalCard__1jdDC {
  border-radius: 12px;
  padding: 1.25rem;
  color: #0f172a;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid transparent;
  align-items: center;
  text-align: center;
}

.styles_totalCard__1jdDC span {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.styles_totalCard__1jdDC strong {
  font-size: 1.5rem;
  color: #ffffff;
}

.styles_totalPis__HvI0L {
  background: #2563eb;
}

.styles_totalCofins__kUlKY {
  background: #dc2626;
}

.styles_totalEconomia__9J4zM {
  background: #16a34a;
}

.styles_distributionGrid__8Dz3Q {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.styles_distributionCard__i5zcS {
  border-radius: 12px;
  padding: 1.25rem;
  background: #f8fafc;
  border: 1px solid #e1e6ee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.styles_distributionCardTitle__RXnZy {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.styles_distributionItem__HYcdc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e1e6ee;
}

.styles_distributionItem__HYcdc:last-child {
  border-bottom: none;
}

.styles_distributionItemTotal__U5KCc {
  border-top: 2px solid #e1e6ee;
  margin-top: 0.5rem;
  padding-top: 1rem;
}

.styles_distributionLabel__Mo7Wc {
  font-size: 0.9rem;
  color: #64748b;
}

.styles_distributionLabelTotal__Sad1P {
  font-size: 0.9rem;
  color: #0f172a;
  font-weight: 600;
}

.styles_distributionValue__oxUYz {
  font-size: 1rem;
  font-weight: 600;
}

.styles_distributionValuePis__KIKeI {
  color: #2563eb;
}

.styles_distributionValueCofins__za7Jn {
  color: #dc2626;
}

.styles_distributionValueTotal__jeu-R {
  color: #0f172a;
  font-size: 1.1rem;
}

.styles_filtrosContainer__1oxBy {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.styles_filtrosRight__8LdmZ {
  display: flex;
  gap: 0.5rem;
}

.styles_botaoExportar__4jzRC {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #ffffff;
  border: 1px solid #e1e6ee;
  border-radius: 8px;
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.styles_botaoExportar__4jzRC:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.styles_botaoExportar__4jzRC:active {
  transform: scale(0.98);
}

.styles_tableContainer__lZWzH {
  margin-top: 1rem;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e1e6ee;
}

.styles_teseText__SKQFy {
  font-size: 0.85rem;
  line-height: 1.6;
  color: #475569;
}

.styles_valorPis__n3vi0 {
  color: #2563eb;
  font-weight: 600;
}

.styles_valorCofins__J2ZDf {
  color: #dc2626;
  font-weight: 600;
}

.styles_tableFooter__AWEuM {
  background-color: #f8fafc;
  font-weight: 600;
}

.styles_textoOpaco__Zym3j {
  opacity: 0.5;
}

.styles_rowFundoCinza__7oHlF {
  background-color: #f5f5f5;
}

.styles_rowFundoBranco__RiqAd {
  background-color: #ffffff;
}

.styles_footer__zRdIB {
  margin-top: 0.15rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.3rem 0 0;
  border-top: 1px solid #e2e8f0;
}

.styles_footerLeft__yBJp8,
.styles_footerRight__16S-F {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .styles_page__ylqiB {
    padding: 2rem 1rem;
  }

  .styles_card__SlTbm {
    padding: 1.5rem;
  }

  .styles_totalsRow__BEStY {
    grid-template-columns: 1fr;
  }

  .styles_distributionGrid__8Dz3Q {
    grid-template-columns: 1fr;
  }

  .styles_footer__zRdIB {
    flex-direction: column;
    align-items: stretch;
  }

  .styles_footerLeft__yBJp8,
  .styles_footerRight__16S-F {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaPISCOFINS/ResumoGeral/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":[".page {\n  min-height: 100vh;\n  padding: 1rem 1rem 2rem;\n}\n\n.card {\n  position: relative;\n  max-width: 1500px;\n  margin: 0.35rem auto 0;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 1.1rem 1.35rem 0.6rem;\n  box-shadow: 0 10px 24px rgba(3, 15, 36, 0.14);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n  padding: 1.25rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e1e6ee;\n}\n\n.infoItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.infoItem strong {\n  color: #0f172a;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.totalsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.totalCard {\n  border-radius: 12px;\n  padding: 1.25rem;\n  color: #0f172a;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  border: 1px solid transparent;\n  align-items: center;\n  text-align: center;\n}\n\n.totalCard span {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.totalCard strong {\n  font-size: 1.5rem;\n  color: #ffffff;\n}\n\n.totalPis {\n  background: #2563eb;\n}\n\n.totalCofins {\n  background: #dc2626;\n}\n\n.totalEconomia {\n  background: #16a34a;\n}\n\n.distributionGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.distributionCard {\n  border-radius: 12px;\n  padding: 1.25rem;\n  background: #f8fafc;\n  border: 1px solid #e1e6ee;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.distributionCardTitle {\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.distributionItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #e1e6ee;\n}\n\n.distributionItem:last-child {\n  border-bottom: none;\n}\n\n.distributionItemTotal {\n  border-top: 2px solid #e1e6ee;\n  margin-top: 0.5rem;\n  padding-top: 1rem;\n}\n\n.distributionLabel {\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.distributionLabelTotal {\n  font-size: 0.9rem;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.distributionValue {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.distributionValuePis {\n  color: #2563eb;\n}\n\n.distributionValueCofins {\n  color: #dc2626;\n}\n\n.distributionValueTotal {\n  color: #0f172a;\n  font-size: 1.1rem;\n}\n\n.filtrosContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n}\n\n.filtrosRight {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.botaoExportar {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  background: #ffffff;\n  border: 1px solid #e1e6ee;\n  border-radius: 8px;\n  color: #0f172a;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.botaoExportar:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.botaoExportar:active {\n  transform: scale(0.98);\n}\n\n.tableContainer {\n  margin-top: 1rem;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e1e6ee;\n}\n\n.teseText {\n  font-size: 0.85rem;\n  line-height: 1.6;\n  color: #475569;\n}\n\n.valorPis {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.valorCofins {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.tableFooter {\n  background-color: #f8fafc;\n  font-weight: 600;\n}\n\n.textoOpaco {\n  opacity: 0.5;\n}\n\n.rowFundoCinza {\n  background-color: #f5f5f5;\n}\n\n.rowFundoBranco {\n  background-color: #ffffff;\n}\n\n.footer {\n  margin-top: 0.15rem;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  padding: 0.3rem 0 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n.footerLeft,\n.footerRight {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .page {\n    padding: 2rem 1rem;\n  }\n\n  .card {\n    padding: 1.5rem;\n  }\n\n  .totalsRow {\n    grid-template-columns: 1fr;\n  }\n\n  .distributionGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .footerLeft,\n  .footerRight {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles_page__ylqiB`,
	"card": `styles_card__SlTbm`,
	"infoGrid": `styles_infoGrid__MCnYQ`,
	"infoItem": `styles_infoItem__cT0C4`,
	"totalsRow": `styles_totalsRow__BEStY`,
	"totalCard": `styles_totalCard__1jdDC`,
	"totalPis": `styles_totalPis__HvI0L`,
	"totalCofins": `styles_totalCofins__kUlKY`,
	"totalEconomia": `styles_totalEconomia__9J4zM`,
	"distributionGrid": `styles_distributionGrid__8Dz3Q`,
	"distributionCard": `styles_distributionCard__i5zcS`,
	"distributionCardTitle": `styles_distributionCardTitle__RXnZy`,
	"distributionItem": `styles_distributionItem__HYcdc`,
	"distributionItemTotal": `styles_distributionItemTotal__U5KCc`,
	"distributionLabel": `styles_distributionLabel__Mo7Wc`,
	"distributionLabelTotal": `styles_distributionLabelTotal__Sad1P`,
	"distributionValue": `styles_distributionValue__oxUYz`,
	"distributionValuePis": `styles_distributionValuePis__KIKeI`,
	"distributionValueCofins": `styles_distributionValueCofins__za7Jn`,
	"distributionValueTotal": `styles_distributionValueTotal__jeu-R`,
	"filtrosContainer": `styles_filtrosContainer__1oxBy`,
	"filtrosRight": `styles_filtrosRight__8LdmZ`,
	"botaoExportar": `styles_botaoExportar__4jzRC`,
	"tableContainer": `styles_tableContainer__lZWzH`,
	"teseText": `styles_teseText__SKQFy`,
	"valorPis": `styles_valorPis__n3vi0`,
	"valorCofins": `styles_valorCofins__J2ZDf`,
	"tableFooter": `styles_tableFooter__AWEuM`,
	"textoOpaco": `styles_textoOpaco__Zym3j`,
	"rowFundoCinza": `styles_rowFundoCinza__7oHlF`,
	"rowFundoBranco": `styles_rowFundoBranco__RiqAd`,
	"footer": `styles_footer__zRdIB`,
	"footerLeft": `styles_footerLeft__yBJp8`,
	"footerRight": `styles_footerRight__16S-F`
};
export default ___CSS_LOADER_EXPORT___;
